import * as React from "react";

const LinkLeadTimesInactive: React.FC = () => (
    <svg
        width="12px"
        height="12px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="currentColor"
            d="M10.875,6 C10.875,7.74166989 9.94583058,9.35103893 8.4375,10.2218735 C6.92916942,11.0927088 5.07083023,11.0927088 3.5625,10.2218735 C2.05416977,9.35103893 1.125,7.74166989 1.125,6 C1.125,4.25833011 2.05416977,2.64896107 3.5625,1.77812576 C5.07083023,0.907291174 6.92916942,0.907291174 8.4375,1.77812576 C9.94583058,2.64896107 10.875,4.25833011 10.875,6 Z M0,6 C0,8.14359355 1.14359343,10.1243556 3,11.1961527 C4.85640657,12.2679491 7.14359379,12.2679491 9,11.1961527 C10.8564062,10.1243556 12,8.14359355 12,6 C12,3.85640645 10.8564062,1.87564445 9,0.803847313 C7.14359379,-0.267949104 4.85640657,-0.267949104 3,0.803847313 C1.14359343,1.87564445 0,3.85640645 0,6 Z M5.4375,2.8125 L5.4375,6 L5.4375,6.29999971 L5.68828118,6.46640611 L7.93828154,7.96640611 L8.40703154,8.27812457 L9.03046918,7.34296846 L8.56171918,7.03125 L6.5625,5.69999993 L6.5625,2.8125 L6.5625,2.25 L5.4375,2.25 L5.4375,2.8125 Z"
            opacity=".5"
        />
    </svg>
);

export default React.memo(LinkLeadTimesInactive);
